package com.iregained.site.components.sections.about.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.calc
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import org.jetbrains.compose.web.css.*

val AboutHeroContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().styleModifier { property("height", "calc(100dvh - 80px)") }
        .minHeight(500.px)
        .position(Position.Relative)
        .overflow(Overflow.Hidden)
}

val AboutHeroBackgroundStyle = CssStyle.base {
    Modifier.position(Position.Absolute).top(0.px).left(0.px).width(100.percent).height(100.percent)
        .objectFit(ObjectFit.Cover)
}

val AboutHeroOverlayStyle = CssStyle.base {
    Modifier.position(Position.Absolute).top(0.px).left(0.px).width(100.percent).height(100.percent)
        // 70% opacity black guarantees text readability
        .backgroundColor(Colors.Black.toRgb().copyf(alpha = 0.60f))
}

val AboutHeroContentColumnStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1000.px).padding(leftRight = 24.px)
        .position(Position.Relative) // Sits naturally on top of the absolute layers
}

val AboutHeroHeadlineStyle = CssStyle.base {
    Modifier.color(Colors.White).fontSize(clamp(2.5.cssRem, 5.vw, 4.5.cssRem)).fontWeight(FontWeight.Bold)
        .textAlign(TextAlign.Center).lineHeight(1.1).margin(bottom = 24.px).whiteSpace(WhiteSpace.PreWrap)
        .textShadow(0.px, 4.px, 12.px, Colors.Black.toRgb().copyf(alpha = 0.8f))
}

val AboutHeroSubheadlineStyle = CssStyle.base {
    Modifier.color(Colors.White.copyf(alpha = 0.9f)).fontSize(1.75.cssRem).fontWeight(FontWeight.Bold).maxWidth(1200.px).textAlign(TextAlign.Center)
        .whiteSpace(WhiteSpace.PreWrap).lineHeight(1.6)
        .textShadow(0.px, 2.px, 6.px, Colors.Black.toRgb().copyf(alpha = 0.8f))
}